export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/20 text-primary-400 border border-primary-500/30 mb-4">
            关于我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
            关于97影视
          </h2>

          <div className="bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-8 text-left">
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              97影视是一个专注于<strong>高清电影免费在线观看</strong>的综合性影视平台。我们致力于为广大影迷提供最新、最全、最高清的<strong>电影大全</strong>，涵盖<strong>动作片</strong>、<strong>喜剧片</strong>、科幻、悬疑、剧情等全类型影片。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              自上线以来，97影视始终秉持"极速播放、高清画质、免费观影"的核心理念，通过自主研发的多线路智能播放引擎，为观众打造流畅不缓冲的观影体验。无论是热门新片还是经典老片，97影视都能让您随时随地畅享电影的魅力。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              我们拥有专业的片源更新团队，每日不间断更新最新<strong>高清电影</strong>资源，确保您在97影视总能找到想看的好电影。未来，我们将继续优化播放体验，丰富影片内容，成为您观影路上的最佳伙伴。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}